import axios from 'axios'

const DEFAULT_QUERY_PATH = '/api/rendering/admin/front/user/deploy/query'

const deployRefreshApi = {
  query(params) {
    return axios.post(DEFAULT_QUERY_PATH, params)
  },
}

export const createDeployRefreshQuery = () => {
  return async (key) => {
    const response = await deployRefreshApi.query({ key })
    const payload = response && response.data ? response.data : null
    const value = payload && Object.prototype.hasOwnProperty.call(payload, 'data')
      ? payload.data
      : payload

    return {
      value,
    }
  }
}

export default deployRefreshApi
